import { render, staticRenderFns } from "./KanriApp.vue?vue&type=template&id=5bbd48f3&"
import script from "./KanriApp.vue?vue&type=script&lang=ts&"
export * from "./KanriApp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports